import request from '../request';

export function getLeadOrders(params) {
    return request({
        url: "driver/client-orders",
        method: "get",
        params
    })
}

export function storeLeadOrder(data) {
    return request({
        url:'dispatcher/client-orders',
        method: 'post',
        data,
    })
}


export function storeAcceptOrder(id) {
    return request({
        url: `driver/accept-order/${id}`,
        method: "put",
    })
}

export function storeDeliveredOrder(id) {
    return request({
        url: `driver/order-delivered/${id}`,
        method: "put",
    })
}

export function storeFinishedOrder(id) {
    return request({
        url: `dispatcher/order-finish/${id}`,
        method: "put",
    })
}

export function moveOrdersDate(data) {
    return request({
        url: '/dispatcher/move-orders-date',
        method: 'put',
        data,
    })
}

export function fetchTemporaryOrders(params) {
    return request({
        url: '/temporary-orders',
        method: 'get',
        params,
    })
}

export function storeTempOrder(data) {
    return request({
        url: '/temporary-orders',
        method: 'post',
        data,
    })
}
